<mat-accordion [displayMode]="'flat'" *ngIf="expandableItems.length > 0">
    <mat-expansion-panel ngClass="no-shadow" *ngFor="let item of expandableItems; trackBy: trackByFn"
                         [hideToggle]="true">
        <mat-expansion-panel-header class="menu-expansion-header" [collapsedHeight]="'56px'"
                                    *ngIf="((item.id!==8 && item.id!==12 && item.id!==18))">
            <mat-icon class="menu-expansion-icon" *ngIf="!esSvg(item.icono); else svgGrupo">{{ ligatura(item.icono) }}</mat-icon>
            <ng-template #svgGrupo>
                <mat-icon class="menu-expansion-icon" [svgIcon]="svgIcono(item.icono)"></mat-icon>
            </ng-template>
            <span class="menu-expansion-name">{{item.name}}</span>
        </mat-expansion-panel-header>
        <app-menu [items]="item.children" [submenu]="true"
                  (itemClicked$)="itemClicked$.next()"></app-menu>
    </mat-expansion-panel>
</mat-accordion>
<mat-nav-list class="menu-final-items" [class.submenu]="submenu" *ngIf="(finalItems.length > 0)">
    <!-- En móvil y tableta (modo consulta) no se ofrece crear trabajos: «Nuevo trabajo» no sale -->
    <ng-container *ngFor="let item of finalItems; trackBy: trackByFn">
      <ng-container *ngIf="!(esSoloEscritorio(item) && (soloConsulta$ | async))">
        <!-- La entrada de ayuda (link = ENLACE_AYUDA) abre el panel en vez de navegar. El icono se
             repite aquí a propósito: con ngTemplateOutlet, mat-list-item no lo reconocería como
             matListIcon y lo pintaría fuera de su hueco. -->
        <a *ngIf="esAyuda(item); else enlace" class="menu-accion" (click)="abrirAyuda()" mat-list-item>
            <ng-container *ngIf="!submenu">
                <mat-icon matListIcon *ngIf="!esSvg(item.icono); else svgAyuda">{{ ligatura(item.icono) }}</mat-icon>
                <ng-template #svgAyuda>
                    <mat-icon matListIcon [svgIcon]="svgIcono(item.icono)"></mat-icon>
                </ng-template>
            </ng-container>
            {{item.name}}
        </a>
        <ng-template #enlace>
            <a [routerLink]="item.link"
               [queryParams]="queryParams(item.queryParams)"
               (click)="itemClicked$.next()" routerLinkActive="active"
               [routerLinkActiveOptions]="{matrixParams: 'exact', queryParams: 'subset', paths: 'exact', fragment: 'ignored'}"
               mat-list-item>
                <ng-container *ngIf="!submenu">
                    <mat-icon matListIcon *ngIf="!esSvg(item.icono); else svgHoja">{{ ligatura(item.icono) }}</mat-icon>
                    <ng-template #svgHoja>
                        <mat-icon matListIcon [svgIcon]="svgIcono(item.icono)"></mat-icon>
                    </ng-template>
                </ng-container>
                {{item.name}}
            </a>
        </ng-template>
      </ng-container>
    </ng-container>
</mat-nav-list>


